import React from 'react'
import * as Yup from 'yup'

import { Field } from 'widgets/Field'
import { Form } from 'widgets/Form'

const initialValues = {
  email: '',
  password: '',
}

interface LoginFormProps {
  errors?: string[] | string
  onSubmit: (e: any) => void
  loading?: boolean
}

const validationSchema = Yup.object().shape({
  email: Yup.string().email().required('Required'),
  password: Yup.string().min(6, 'Too Short!').required('Required'),
})

export const LoginForm = ({
  errors = [],
  onSubmit = () => null,
  loading = false,
}: LoginFormProps) => {
  return (
    <Form
      errors={errors}
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={onSubmit}
      loading={loading}
      submitCopy='LOG IN'
    >
      {() => (
        <>
          <Field name='email' placeholder='Email' />
          <Field name='password' type='password' placeholder='Password' />
        </>
      )}
    </Form>
  )
}
